let filterTrigger = document.querySelector('.filter-toggle');
filterTrigger.addEventListener('click', () => {
    let filterList = document.querySelector('.filter-menu');
    filterList.classList.add('active');
    if (filterList.classList.contains('active')){
        filterTrigger.classList.add('active');
    }
});


document.addEventListener('click', function(event) {
    if (!document.querySelector('.collection-filters-title').contains(event.target) && event.target.closest(".filter-menu") === null) {
      document.querySelector('.filter-menu').classList.remove('active');
    }
});